import { ReactComponent as SearchIcon } from '../../Assets/img/Search-white-icon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import { ReactComponent as AddIcon } from '../../Assets/img/Add-primary-icon.svg';
import { ReactComponent as UploadIcon } from '../../Assets/img/Upload-primary-icon.svg';
import { ReactComponent as FilterGrpOnIcon } from '../../Assets/img/Filter-grp-on-icon.svg';
import { ReactComponent as FilterGrpOnIconHover } from '../../Assets/img/Filter-grp-on-icon-hover.svg';
import { ReactComponent as FilterGrpOffIcon } from '../../Assets/img/Filter-grp-off-icon.svg';
import { ReactComponent as FilterGrpOffIconHover } from '../../Assets/img/Filter-grp-off-icon-hover.svg';
import { ReactComponent as MenuIcon } from '../../Assets/img/Menu-icon.svg';
import { ReactComponent as MenuIconHover } from '../../Assets/img/Menu-icon-hover.svg';
import ReactPopup from 'reactjs-popup';

function PageTop(props) {
    return (
        <div className="pagetop-container">
            <div className="pagetop-search-container">
                <input type="text" className="pagetop-searchbox" placeholder={props.searchPlaceholder} ref={props.searchRef} />
                <button type="button" className="primary-button pagetop-searchbutton" onClick={props.searchAllColumnHandler}>
                    <span className="primary-button-icon"><SearchIcon /></span>
                    <span className="primary-button-text">Search</span>
                </button>
            </div>
            <div className="pagetop-buttons-container">
                <button style={{ marginLeft: "1%" }} type="button" className="secondary-button" onClick={props.resetPageHandler}>
                    <span className="secondary-button-icon"><ResetIcon /></span>
                    <span className="secondary-button-text">Reset</span>
                </button>
                <button style={{ marginLeft: "1%" }} type="button" className="secondary-button" onClick={() => props.modelOpenHandler("add")}>
                    <span className="secondary-button-icon"><AddIcon /></span>
                    <span className="secondary-button-text">{props.addButtonText}</span>
                </button>
                {props.disableSecondAddButton == null &&
                    <button style={{ marginLeft: "1%" }} type="button" className="secondary-button" onClick={() => props.modelOpenHandler("create")}>
                        <span className="secondary-button-icon"><AddIcon /></span>
                        <span className="secondary-button-text">{props.secondAddButtonText}</span>
                    </button>}
                {props.disableUploadButton == null &&
                    <button style={{ marginLeft: "1%" }} type="button" className="secondary-button" onClick={() => props.modelOpenHandler("upload")}>
                        <span className="secondary-button-icon"><UploadIcon /></span>
                        <span className="secondary-button-text">{props.uploadButtonText}</span>
                    </button>}
                <div className="filter-icon-container" onClick={props.filterColumnHandler} >
                    {props.showFilter ?
                        <FilterGrpOffIcon className="filter-icon" /> :
                        <FilterGrpOnIcon className="filter-icon" />
                    }
                    {props.showFilter ?
                        <FilterGrpOffIconHover className="filter-icon hover-icon" /> :
                        <FilterGrpOnIconHover className="filter-icon hover-icon" />
                    }
                </div>
                <div style={{ borderLeft: "1px solid #0000001F", marginLeft: "1.5%" }}></div>    
                <ReactPopup
                    trigger={<div className="menu-icon-container">
                        <MenuIcon className="menu-icon" />
                        <MenuIconHover className="menu-icon hover-icon" />
                    </div>}
                    position="bottom right" arrow={false} contentStyle={{ background: '#FFFFFF',borderRadius:'4px' }} overlayStyle={{ background: '#00000030' }}>                
                    {props.menuData}
                </ReactPopup>
            </div>
        </div>
    );
}

export default PageTop;